import React from 'react';
import PropTypes from "prop-types";
import {useDispatch} from "react-redux";

import MindsetsJsSDK, {LoadedAutocompleteItemsAction, LoadedAutocompleteTotalsAction} from "../../index";
import {EXPRESSION_TRUE} from "../../constants/filter";
import Autocomplete from "./Autocomplete";
import ChallengeDropdownItem from "./ChallengeDropdownItem";

function ChallengeDropdown(
    {
        default_value,
        placeholder = 'Name or code',
        container_class,
        input_class,
        show_add_always = false,
        label,
        label_class,
        renderAdd,
        onSelect,
        id,
        with_reset = false,
        disabled = false,
        match_dropdown_width = false,
        show_counts = false,
        onReset,
        debounce,
        limit = 25,
        unversioned = false
    }
) {
    const dispatch = useDispatch();

    function loadChallengeVersions(q) {
        let options = {q, order_by: 'name', order_direction: 'asc', limit};
        if (unversioned) {
            options['filters[unversioned][0]'] = EXPRESSION_TRUE;
        }
        MindsetsJsSDK().API
            .get('challenge_versions', options)
            .then(response => {
                dispatch(LoadedAutocompleteItemsAction(id, response.items));
                dispatch(LoadedAutocompleteTotalsAction(id, response.total));
            });
    }

    function getChallengeVersions(q) {
        if (typeof debounce === 'function') {
            debounce(function () {
                loadChallengeVersions(q);
            });
        } else {
            loadChallengeVersions(q);
        }
    }

    return (
        <Autocomplete
            id={id}
            placeholder={placeholder}
            fetchItems={getChallengeVersions}
            onSelect={onSelect}
            label={label}
            label_class={label_class}
            renderItem={item => <ChallengeDropdownItem item={item} with_version={!!unversioned}/>}
            default_value={default_value}
            persist_value={true}
            always_show_add={show_add_always}
            renderAdd={renderAdd}
            container_class={container_class}
            input_class={input_class}
            with_reset={with_reset}
            onReset={onReset}
            disabled={disabled}
            match_dropdown_width={match_dropdown_width}
            onChange={() => onSelect(null)}
            show_counts={show_counts}
        />
    )
}

ChallengeDropdown.propTypes = {
    default_value: PropTypes.string,
    placeholder: PropTypes.string,
    container_class: PropTypes.string,
    input_class: PropTypes.string,
    show_add_always: PropTypes.bool,
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.object,
        PropTypes.element,
    ]),
    label_class: PropTypes.string,
    renderAdd: PropTypes.func,
    onSelect: PropTypes.func.isRequired,
    with_reset: PropTypes.bool,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
    match_dropdown_width: PropTypes.bool,
    show_counts: PropTypes.bool,
    onReset: PropTypes.func,
    debounce: PropTypes.func,
    limit: PropTypes.number,
    unversioned: PropTypes.bool
};

export default ChallengeDropdown;
